import { ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { H2 } from 'components/Text/H2';
import { CloseButton, Dialog, ModalBase } from 'modals/ModalBase';
import { breakpoints, colors } from 'theme';

const StyledDialog = styled(Dialog)<{
  $maxWidth?: 'none' | number;
  wide?: boolean;
}>`
  background-image: linear-gradient(to left, #1d91e9, ${colors.hoverBlue});
  background-size: 100% 7px;
  background-repeat: no-repeat;
  padding-top: 42px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 35px;
  ${(props) =>
    props.$maxWidth === 'none'
      ? 'max-width: none;'
      : `max-width: ${props.$maxWidth}px;`}
  @media (min-width: ${breakpoints[2]}) {
    padding-top: 40px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 40px;
    ${(props) => props.wide && `min-width: 650px`}
  }
`;

const StyledCloseButton = styled(CloseButton)`
  color: ${colors.lightContentGrey};
  &:hover {
    color: ${colors.brandBlue};
    &:disabled {
      &:hover {
        color: ${colors.lightContentGrey};
      }
    }
  }
`;

type Props = {
  children: ReactNode;
  className?: string;
  uncloseable?: boolean;
  customOverlay?: ReactNode;
  title?: ReactNode;
  onClose?: () => void;
  'data-qa-id'?: string;
  wide?: boolean;
  maxWidth?: 'none' | number;
};

export function Modal({
  children,
  className,
  uncloseable,
  customOverlay,
  title,
  onClose,
  wide,
  'data-qa-id': dataQaId,
  maxWidth,
}: Props) {
  return (
    <ModalBase
      className={className}
      onClose={onClose}
      customOverlay={customOverlay}
    >
      <StyledDialog data-qa-id={dataQaId} wide={wide} $maxWidth={maxWidth}>
        {onClose && !uncloseable && (
          <StyledCloseButton
            onClick={onClose}
            data-qa-id="close-modal-button"
            data-modal-focus="false"
          />
        )}

        <Box>
          {title && (
            <H2 styleAs="h3" pb={2}>
              {title}
            </H2>
          )}

          {children}
        </Box>
      </StyledDialog>
    </ModalBase>
  );
}
